<template>
  <section class="py-12">
    <MicsContainer>
      <div v-if="activeTab" class="mb-8 flex flex-wrap items-center justify-between gap-4 md:gap-0">
        <select id="default"
                class="md:hidden w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                @change="setTabIndex">
          <option v-for="(tab, index) in tabs" :selected="tab.name == activeTab.name" :value="index">{{$t('tabs.' + tab.name)}}</option>
        </select>
        <ul class="hidden md:flex flex-wrap gap-8 text-sm font-medium text-center text-gray-500 dark:text-gray-400">
          <li v-for="tab in tabs">
            <a href="#"  @click.prevent="setTab(tab)" class="inline-block px-5 py-2.5 rounded-md" :class="tab.name == activeTab.name ? 'text-white bg-primary-900' : 'hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white'">{{$t('tabs.' + tab.name)}}</a>
          </li>
        </ul>

        <button type="button"
                class="hidden w-full md:w-auto flex items-center justify-center gap-2 py-2.5 px-5 text-sm font-medium text-gray-800 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
          <svg class="w-3.5 h-3.5 text-current" xmlns="http://www.w3.org/2000/svg" width="14" height="15"
               viewBox="0 0 14 15" fill="none">
            <path
                d="M0.7 4.03118H1.6968C1.84221 4.48405 2.12922 4.87933 2.51631 5.15983C2.90339 5.44034 3.37048 5.59153 3.85 5.59153C4.32952 5.59153 4.79661 5.44034 5.18369 5.15983C5.57078 4.87933 5.85779 4.48405 6.0032 4.03118H13.3C13.4857 4.03118 13.6637 3.95809 13.795 3.82798C13.9263 3.69788 14 3.52142 14 3.33742C14 3.15342 13.9263 2.97696 13.795 2.84686C13.6637 2.71675 13.4857 2.64366 13.3 2.64366H6.0032C5.85779 2.19079 5.57078 1.79552 5.18369 1.51501C4.79661 1.2345 4.32952 1.08331 3.85 1.08331C3.37048 1.08331 2.90339 1.2345 2.51631 1.51501C2.12922 1.79552 1.84221 2.19079 1.6968 2.64366H0.7C0.514348 2.64366 0.336301 2.71675 0.205025 2.84686C0.0737498 2.97696 0 3.15342 0 3.33742C0 3.52142 0.0737498 3.69788 0.205025 3.82798C0.336301 3.95809 0.514348 4.03118 0.7 4.03118ZM3.85 2.47022C4.02306 2.47022 4.19223 2.52108 4.33612 2.61637C4.48002 2.71166 4.59217 2.8471 4.65839 3.00556C4.72462 3.16402 4.74195 3.33838 4.70819 3.5066C4.67443 3.67482 4.59109 3.82934 4.46872 3.95062C4.34635 4.0719 4.19044 4.1545 4.0207 4.18796C3.85097 4.22142 3.67504 4.20425 3.51515 4.13861C3.35527 4.07297 3.21861 3.96182 3.12246 3.81921C3.02632 3.6766 2.975 3.50894 2.975 3.33742C2.97537 3.10754 3.06768 2.88718 3.23169 2.72462C3.3957 2.56207 3.61805 2.47059 3.85 2.47022Z"
                fill="#1F2A37"/>
            <path
                d="M13.3 10.9688H6.0032C5.85779 10.5159 5.57078 10.1206 5.18369 9.84013C4.79661 9.55962 4.32952 9.40843 3.85 9.40843C3.37048 9.40843 2.90339 9.55962 2.51631 9.84013C2.12922 10.1206 1.84221 10.5159 1.6968 10.9688H0.7C0.514348 10.9688 0.336301 11.0419 0.205025 11.172C0.0737498 11.3021 0 11.4785 0 11.6625C0 11.8465 0.0737498 12.023 0.205025 12.1531C0.336301 12.2832 0.514348 12.3563 0.7 12.3563H1.6968C1.84221 12.8092 2.12922 13.2044 2.51631 13.485C2.90339 13.7655 3.37048 13.9166 3.85 13.9166C4.32952 13.9166 4.79661 13.7655 5.18369 13.485C5.57078 13.2044 5.85779 12.8092 6.0032 12.3563H13.3C13.4857 12.3563 13.6637 12.2832 13.795 12.1531C13.9263 12.023 14 11.8465 14 11.6625C14 11.4785 13.9263 11.3021 13.795 11.172C13.6637 11.0419 13.4857 10.9688 13.3 10.9688ZM3.85 12.5297C3.67694 12.5297 3.50777 12.4789 3.36388 12.3836C3.21998 12.2883 3.10783 12.1529 3.04161 11.9944C2.97538 11.8359 2.95805 11.6616 2.99181 11.4934C3.02557 11.3251 3.10891 11.1706 3.23128 11.0493C3.35365 10.9281 3.50956 10.8455 3.6793 10.812C3.84903 10.7785 4.02496 10.7957 4.18485 10.8614C4.34473 10.927 4.48139 11.0381 4.57754 11.1807C4.67368 11.3234 4.725 11.491 4.725 11.6625C4.72463 11.8924 4.63232 12.1128 4.46831 12.2753C4.3043 12.4379 4.08195 12.5294 3.85 12.5297Z"
                fill="#1F2A37"/>
            <path
                d="M13.3 6.80622H12.3032C12.1578 6.35335 11.8708 5.95807 11.4837 5.67757C11.0966 5.39706 10.6295 5.24587 10.15 5.24587C9.67048 5.24587 9.20339 5.39706 8.81631 5.67757C8.42922 5.95807 8.14221 6.35335 7.9968 6.80622H0.7C0.514348 6.80622 0.336301 6.87931 0.205025 7.00942C0.0737498 7.13952 0 7.31598 0 7.49998C0 7.68398 0.0737498 7.86044 0.205025 7.99054C0.336301 8.12065 0.514348 8.19374 0.7 8.19374H7.9968C8.14221 8.64661 8.42922 9.04189 8.81631 9.32239C9.20339 9.6029 9.67048 9.75409 10.15 9.75409C10.6295 9.75409 11.0966 9.6029 11.4837 9.32239C11.8708 9.04189 12.1578 8.64661 12.3032 8.19374H13.3C13.4857 8.19374 13.6637 8.12065 13.795 7.99054C13.9263 7.86044 14 7.68398 14 7.49998C14 7.31598 13.9263 7.13952 13.795 7.00942C13.6637 6.87931 13.4857 6.80622 13.3 6.80622ZM10.15 8.36718C9.97694 8.36718 9.80777 8.31632 9.66388 8.22103C9.51998 8.12574 9.40783 7.9903 9.34161 7.83184C9.27538 7.67338 9.25805 7.49902 9.29181 7.3308C9.32557 7.16258 9.40891 7.00806 9.53128 6.88678C9.65365 6.7655 9.80956 6.6829 9.9793 6.64944C10.149 6.61598 10.325 6.63316 10.4848 6.69879C10.6447 6.76443 10.7814 6.87558 10.8775 7.01819C10.9737 7.1608 11.025 7.32846 11.025 7.49998C11.0246 7.72986 10.9323 7.95022 10.7683 8.11278C10.6043 8.27533 10.382 8.36681 10.15 8.36718Z"
                fill="#1F2A37"/>
          </svg>
          More filters
        </button>
      </div>
      <!-- Skeleton loader -->
      <div v-if="loading"
           class="flex flex-nowrap overflow-scroll sm:overflow-auto -mx-4 px-4 sm:mx-0 sm:px-0 sm:grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-8">
        <CardPropertySkeleton v-for="n in 12" :key="n"/>
      </div>
      <!-- Actual content -->
      <div v-else-if="hits && hits.length > 0"
           class="flex flex-nowrap overflow-scroll sm:overflow-auto -mx-4 px-4 sm:mx-0 sm:px-0 sm:grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-8">
        <CardProperty :package-order="packageOrder" v-for="hit in hits" :key="hit.id" :listing="hit" :open-in-new-window="true"/>
      </div>
      <div v-if="hits && hits.length > 0 && !loading" class="mt-10 flex justify-center">
        <button 
           @click="showMore"
           class="w-full md:w-auto md:px-20 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          {{$t('buttons.more_properties')}} ({{ morePropertiesText }})
        </button>
      </div>
    </MicsContainer>
  </section>
</template>

<script setup lang="ts">
import { ref, toRaw } from 'vue';
import {useWebsiteConfigurationStore} from '~/stores/websiteConfigurationStore';
const websiteConfigurationStore = useWebsiteConfigurationStore();
const {result, search} = useAlgoliaSearch('listings')
const hits = ref([]);
const packageOrder = ref('min_stay');
const totalHits = ref(0);
const loading = ref(true);
var hitsPerPage = 12;

const tabs = [
  {
    name: 'mid_term_rentals',
    filters: 'announce_type:property-announces AND packages.min<7',
    packageOrder: 'min_stay'
  },
];
const activeTab = ref(null);
const period = ref('monthly');

const morePropertiesText = computed(() => {
  const remainingProperties = totalHits.value - hitsPerPage;
  if (remainingProperties > 100) {
    return '100+';
  }
  return Math.max(0, remainingProperties);
});

function setTabIndex(event) {
  setTab(tabs[event.target.value]);
}

async function showMore() {
  hitsPerPage += 12;
  await setTab(activeTab.value);
}

async function setTab(tab) {
  loading.value = true;
  activeTab.value = tab;
  await search({
    requestOptions: {
      hitsPerPage: hitsPerPage,
      filters: `language_code:${websiteConfigurationStore.configuration.languageCode} AND listing_id:${websiteConfigurationStore.configuration.listingId} AND ` + tab.filters
    },
  });
  packageOrder.value = tab.packageOrder;
  totalHits.value = result.value.nbHits;
  hits.value = toRaw(result.value.hits); // Assuming the result has a hits array
  loading.value = false;
}

onMounted(async () => {
  setTab(tabs[0]);
})
</script>